<script setup>
import { useUi } from '@/stores/ui.js'

const ui = useUi()
const icons = { info: 'fa-circle-info text-blue-500', success: 'fa-circle-check text-emerald-500', error: 'fa-circle-exclamation text-red-500', warning: 'fa-triangle-exclamation text-amber-500' }
</script>

<template>
  <!-- At the top, below the search bar: dialogs and panels keep their buttons at the bottom. -->
  <div class="pointer-events-none fixed inset-x-0 top-14 z-[1000] flex flex-col items-center gap-2 px-3 sm:items-end sm:px-5" aria-live="polite">
    <TransitionGroup enter-active-class="transition duration-200" enter-from-class="-translate-y-2 opacity-0" leave-active-class="transition duration-150" leave-to-class="opacity-0">
      <div v-for="toast in ui.toasts" :key="toast.id" class="surface pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-xl border border-default px-4 py-3 shadow-lg">
        <i :class="['fa-solid mt-0.5', icons[toast.kind] || icons.info]" aria-hidden="true"></i>
        <p v-private class="min-w-0 flex-1 text-sm">{{ toast.message }}</p>
        <button v-if="toast.action" type="button" class="link text-sm font-medium" @click="toast.action.run(); ui.dismiss(toast.id)">{{ toast.action.label }}</button>
        <button type="button" class="text-faint hover:text-[var(--text)]" :aria-label="$t('common.close')" @click="ui.dismiss(toast.id)"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </div>
    </TransitionGroup>
  </div>
</template>
